var _style, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1283.6914062 1283.6912842",
    style: {
      enableBackground: "new 0 0 1283.6914062 1283.6912842"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{clip-path:url(#SVGID_00000068666063016376122970000002326251224024311956_);}\n\t.st2{fill:url(#SVGID_00000032651024176435339820000006789117843049737639_);}\n\t.st3{fill:url(#SVGID_00000131333918334591960890000015703090153111037846_);}\n\t.st4{fill:url(#SVGID_00000026128677781726365870000016401936801105430461_);}\n\t.st5{fill:url(#SVGID_00000032647985294961308900000011860390706283123387_);}\n\t.st6{fill:url(#SVGID_00000050651288657605985230000014854800514526616992_);}\n\t.st7{fill:url(#SVGID_00000122715323869524959300000017834904716806843056_);}\n\t.st8{fill:url(#SVGID_00000163783659670322678640000018419373149145736103_);}\n\t.st9{fill:url(#SVGID_00000026843138180488529710000012368217085605685905_);}\n\t.st10{fill:url(#SVGID_00000034805501679150325750000003600837455811338642_);}\n\t.st11{fill:url(#SVGID_00000151521661685933061090000006206253042509331118_);}\n\t.st12{fill:url(#SVGID_00000046336551667541910670000005338300388730908050_);}\n\t.st13{fill:url(#SVGID_00000028283816148055694130000005030520493352474508_);}\n\t.st14{fill:url(#SVGID_00000114786860875842982840000003443175263725633429_);}\n\t.st15{fill:url(#SVGID_00000075124103281185704440000018415154942387608204_);}\n\t.st16{fill:url(#SVGID_00000000195968878339052150000011350787594016634254_);}\n\t.st17{fill:url(#SVGID_00000014618300675543134640000007404287889267980687_);}\n\t.st18{fill:url(#SVGID_00000103234583191721040770000002797114621529242300_);}\n\t.st19{fill:url(#SVGID_00000161605874051602879080000017688299055213660091_);}\n\t.st20{fill:url(#SVGID_00000054984101194003771750000008301546595455209131_);}\n\t.st21{fill:url(#SVGID_00000109714081455317668100000000058129770969597069_);}\n\t.st22{fill:url(#SVGID_00000144308351157046421790000017806419129088028855_);}\n\t.st23{fill:url(#SVGID_00000070076230143354795990000007964078356392153257_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 641.8456421,
    x2: 1283.6914062,
    y2: 641.8456421
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7CA33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F3762B"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 641.8457031,
    cy: 641.8456421,
    r: 641.8456421
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000119103141390065607680000013605386207799438999_",
    cx: 641.8457031,
    cy: 641.8456421,
    r: 641.8456421
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080909397239334473550000007991579994487747469_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119103141390065607680000013605386207799438999_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000080909397239334473550000007991579994487747469_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183248282846318207710000015833244667533631130_",
    gradientUnits: "userSpaceOnUse",
    x1: 448.567688,
    y1: 906.3577881,
    x2: 1168.6286621,
    y2: 906.3577881
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7CA33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F3762B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183248282846318207710000015833244667533631130_)"
    },
    d: "M1159.7124023,868.5928955 c0-20.7706299-16.9942627-37.7648315-37.7648926-37.7648315H486.3326111 c-20.770813,0-37.7649231,16.9941406-37.7649231,37.7648315s16.9941101,37.7648926,37.7649231,37.7648926h188.391571 c20.7704468,0,37.7643433,16.9942017,37.7643433,37.7648926c0,20.7709351-16.9938965,37.7648315-37.7643433,37.7648315 h456.1397095c20.7703857,0,36.135376-16.9938965,36.135376-37.7648315h1.6293945 c0-20.7706909-16.9943848-37.7648926-37.7647705-37.7648926h-8.9163818 C1142.7181396,906.3577881,1159.7124023,889.3635864,1159.7124023,868.5928955z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097459621428447026030000013062133089252883366_",
    gradientUnits: "userSpaceOnUse",
    x1: 448.567688,
    y1: 528.7088623,
    x2: 1160.7783203,
    y2: 528.7088623
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7CA33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F3762B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097459621428447026030000013062133089252883366_)"
    },
    d: "M1159.1489258,490.9439087h1.6293945 c0-20.7707214-16.9942627-37.764801-37.7647705-37.764801H666.8737793 c20.7704468,0,37.7643433,16.9940796,37.7643433,37.764801c0,20.770874-16.9938965,37.7647705-37.7643433,37.7647705 H486.3326111c-20.7707214,0-37.7649231,16.9943237-37.7649231,37.7648926v0.0001221 c0,20.7706909,16.9942017,37.7648926,37.7649231,37.7648926h616.7322998 c20.770752,0,37.7650146-16.9942017,37.7650146-37.7648926v-0.0001221 c0-20.7705688-16.9942627-37.7648926-37.7650146-37.7648926h19.9486084 C1143.7840576,528.7086792,1159.1489258,511.7147827,1159.1489258,490.9439087z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129909082167976045000000005246998584931803309_",
    gradientUnits: "userSpaceOnUse",
    x1: 390.2865906,
    y1: 717.5332642,
    x2: 1564.0583496,
    y2: 717.5332642
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7CA33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F3762B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129909082167976045000000005246998584931803309_)"
    },
    d: "M1526.293457,679.7683716 h-404.3459473c20.7703857,0,37.7647705-16.9939575,37.7647705-37.7648926 c0-20.7706909-16.9943848-37.7647705-37.7647705-37.7647705h-598.159729 c20.7704468,0,37.7643433,16.9940796,37.7643433,37.7647705c0,20.7709351-16.9938965,37.7648926-37.7643433,37.7648926 h-95.7362671c-20.7707214,0-37.7649231,16.9942017-37.7649231,37.7648315v0.000061 c0,20.770752,16.9942017,37.7649536,37.7649231,37.7649536h181.602356 c20.7704468,0,37.7643433,16.9942017,37.7643433,37.7648926c0,20.770874-16.9938965,37.7647705-37.7643433,37.7647705 h466.1141968c20.7705078,0,37.7648926-16.9938965,37.7648926-37.7647705 c0-20.7706909-16.9943848-37.7648926-37.7648926-37.7648926h450.5253906 c20.7706299,0,37.7648926-16.9942017,37.7648926-37.7649536v-0.000061 C1564.0583496,696.7625732,1547.0640869,679.7683716,1526.293457,679.7683716z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097480081956751534930000010424306742126605722_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.8128967,
    y1: 339.8840942,
    x2: 1381.5844727,
    y2: 339.8840942
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7CA33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F3762B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097480081956751534930000010424306742126605722_)"
    },
    d: "M245.5778046,377.6489868 h1098.2419434c20.770752,0,37.7647705-16.9942017,37.7647705-37.764801v-0.0000916 c0-20.7706909-16.9940186-37.7648926-37.7647705-37.7648926H245.5778046 c-20.7705994,0-37.7649078,16.9942017-37.7649078,37.7648926v0.0000916 C207.8128967,360.6547852,224.8072052,377.6489868,245.5778046,377.6489868z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000015334442673144043180000016910606207659009448_",
    gradientUnits: "userSpaceOnUse",
    x1: 734.7114868,
    y1: 264.354248,
    x2: 1228.6159668,
    y2: 264.354248
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7CA33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F3762B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000015334442673144043180000016910606207659009448_)"
    },
    d: "M772.4758301,264.354187 c0,20.7709961-16.9938354,37.7648926-37.7643433,37.7648926h456.1397095 c20.7703857,0,36.135376-16.9938965,36.135376-37.7648926h1.6293945c0-20.7706604-16.9943848-37.7647858-37.7647705-37.7647858 H734.7114868C755.4819946,226.5894012,772.4758301,243.5835266,772.4758301,264.354187z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131334309456357327950000001561104415624245376_",
    gradientUnits: "userSpaceOnUse",
    x1: 366.980896,
    y1: 113.2946472,
    x2: 1158.4219971,
    y2: 113.2946472
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7CA33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F3762B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000131334309456357327950000001561104415624245376_)"
    },
    d: "M404.7457886,75.5298004H565.338623 c20.7703857,0,37.7642822,16.9940948,37.7642822,37.7647934c0,20.7710037-16.9938965,37.7649002-37.7642822,37.7649002 h-61.414032c-20.7706909,0-37.7648926,16.9942017-37.7648926,37.7648926v0.0001068 c0,20.7705994,16.9942017,37.764801,37.7648926,37.764801h616.7325439c20.770752,0,37.7648926-16.9942017,37.7648926-37.764801 v-0.0001068c0-20.7706909-16.9941406-37.7648926-37.7648926-37.7648926h-99.178833 c20.7703857,0,36.135498-16.9938965,36.135498-37.7649002h1.6292725c0-20.7706985-16.9943848-37.7647934-37.7647705-37.7647934 h-0.000061c20.7706909,0,37.7648315-16.9942017,37.7648315-37.7649002v-0.000103 C1059.243042,16.9941998,1042.2489014,0,1021.4782104,0H404.7457886 c-20.7705994,0-37.7648926,16.9941998-37.7648926,37.7647972v0.000103 C366.980896,58.5355988,383.9751892,75.5298004,404.7457886,75.5298004z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177482548871177475990000016789517894796938131_",
    gradientUnits: "userSpaceOnUse",
    x1: 386.3364868,
    y1: 415.414032,
    x2: 1140.8299561,
    y2: 415.414032
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7CA33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F3762B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000177482548871177475990000016789517894796938131_)"
    },
    d: "M1140.8299561,415.414093v-0.0000916 c0-20.7707214-16.9942627-37.7648926-37.7650146-37.7648926h-678.963501 c-20.770813,0-37.7649231,16.9941711-37.7649231,37.7648926v0.0000916 c0,20.7706909,16.9941101,37.7648926,37.7649231,37.7648926h678.963501 C1123.8356934,453.1789856,1140.8299561,436.1847839,1140.8299561,415.414093z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062898656423014809090000012855715013163108269_",
    gradientUnits: "userSpaceOnUse",
    x1: 501.4309082,
    y1: 1170.7122803,
    x2: 995.3353882,
    y2: 1170.7122803
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7CA33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F3762B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062898656423014809090000012855715013163108269_)"
    },
    d: "M501.4309082,1208.4770508 h456.1397705c20.7703247,0,36.135437-16.9937744,36.135437-37.7646484h1.6292725 c0-20.770752-16.9943848-37.7648926-37.7647095-37.7648926H501.4309082 c20.7705078,0,37.7644043,16.9941406,37.7644043,37.7648926 C539.1953125,1191.4832764,522.201416,1208.4770508,501.4309082,1208.4770508z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036967361301955466570000010017554437584857009_",
    gradientUnits: "userSpaceOnUse",
    x1: 176.6972961,
    y1: 1019.6525269,
    x2: 1350.4689941,
    y2: 1019.6525269
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7CA33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F3762B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036967361301955466570000010017554437584857009_)"
    },
    d: "M1312.7041016,981.8876953H214.462204 c-20.7707062,0-37.7649078,16.9940796-37.7649078,37.7647705v0.0001221 c0,20.7706299,16.9942017,37.7647705,37.7649078,37.7647705h1098.2419434 c20.770752,0,37.7648926-16.9941406,37.7648926-37.7647705v-0.0001221 C1350.4689941,998.8817749,1333.4748535,981.8876953,1312.7041016,981.8876953z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109734638304378526540000010698184952125637530_",
    gradientUnits: "userSpaceOnUse",
    x1: 320.7427063,
    y1: 1246.2420654,
    x2: 1013.0048828,
    y2: 1246.2420654
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7CA33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F3762B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109734638304378526540000010698184952125637530_)"
    },
    d: "M975.2399902,1208.4771729 H358.5075989c-20.7706909,0-37.7648926,16.9942627-37.7648926,37.7648926 c0,20.770874,16.9942017,37.7648926,37.7648926,37.7648926h616.7324219 c20.7706299,0,37.7648926-16.9940186,37.7648926-37.7648926 C1013.0048828,1225.4714355,996.0106201,1208.4771729,975.2399902,1208.4771729z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134959751795076211550000008142147459304025227_",
    gradientUnits: "userSpaceOnUse",
    x1: 329.1166077,
    y1: 1095.1824951,
    x2: 1083.6099854,
    y2: 1095.1824951
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7CA33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F3762B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134959751795076211550000008142147459304025227_)"
    },
    d: "M1083.6099854,1095.1824951 v-0.0001221c0-20.7706299-16.9941406-37.7648926-37.7648926-37.7648926H366.8814087 c-20.7707214,0-37.764801,16.9942627-37.764801,37.7648926v0.0001221c0,20.770752,16.9940796,37.7648926,37.764801,37.7648926 h678.9636841C1066.6158447,1132.9473877,1083.6099854,1115.9532471,1083.6099854,1095.1824951z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056419014602652626430000007145811825751180188_",
    gradientUnits: "userSpaceOnUse",
    x1: 840.8154907,
    y1: 906.3577881,
    x2: 1560.8764648,
    y2: 906.3577881
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3762B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F72A33"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000056419014602652626430000007145811825751180188_)"
    },
    d: "M1551.9602051,868.5928955 c0-20.7706299-16.9942627-37.7648315-37.7648926-37.7648315H878.5803833 c-20.7706909,0-37.7648926,16.9941406-37.7648926,37.7648315s16.9942017,37.7648926,37.7648926,37.7648926h188.3916626 c20.7705078,0,37.7642822,16.9942017,37.7642822,37.7648926c0,20.7709351-16.9937744,37.7648315-37.7642822,37.7648315 h456.1396484c20.7703857,0,36.135498-16.9938965,36.135498-37.7648315h1.6292725 c0-20.7706909-16.9943848-37.7648926-37.7647705-37.7648926h-8.9163818 C1534.9659424,906.3577881,1551.9602051,889.3635864,1551.9602051,868.5928955z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072244131894392149380000009333107746692436107_",
    gradientUnits: "userSpaceOnUse",
    x1: 840.8154907,
    y1: 528.7088623,
    x2: 1553.026123,
    y2: 528.7088623
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3762B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F72A33"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072244131894392149380000009333107746692436107_)"
    },
    d: "M1551.3968506,490.9439087h1.6292725 c0-20.7707214-16.9942627-37.764801-37.7647705-37.764801H1059.121582 c20.7705078,0,37.7642822,16.9940796,37.7642822,37.764801c0,20.770874-16.9937744,37.7647705-37.7642822,37.7647705 H878.5803833c-20.7706909,0-37.7648926,16.9943237-37.7648926,37.7648926v0.0001221 c0,20.7706909,16.9942017,37.7648926,37.7648926,37.7648926h616.7323608 c20.770752,0,37.7650146-16.9942017,37.7650146-37.7648926v-0.0001221 c0-20.7705688-16.9942627-37.7648926-37.7650146-37.7648926h19.9486084 C1536.0318604,528.7086792,1551.3968506,511.7147827,1551.3968506,490.9439087z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098212957066936738570000016461677947621019048_",
    gradientUnits: "userSpaceOnUse",
    x1: 782.5344238,
    y1: 717.5332642,
    x2: 1956.3061523,
    y2: 717.5332642
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3762B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F72A33"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098212957066936738570000016461677947621019048_)"
    },
    d: "M1918.5412598,679.7683716 h-404.3459473c20.7703857,0,37.7647705-16.9939575,37.7647705-37.7648926 c0-20.7706909-16.9943848-37.7647705-37.7647705-37.7647705H916.0357056 c20.7703247,0,37.7642822,16.9940796,37.7642822,37.7647705c0,20.7709351-16.9939575,37.7648926-37.7642822,37.7648926 h-95.7363892c-20.7706299,0-37.7648926,16.9942017-37.7648926,37.7648315v0.000061 c0,20.770752,16.9942627,37.7649536,37.7648926,37.7649536h181.602478 c20.7703247,0,37.7643433,16.9942017,37.7643433,37.7648926c0,20.770874-16.9940186,37.7647705-37.7643433,37.7647705 h466.1141968c20.7703857,0,37.7647705-16.9938965,37.7647705-37.7647705 c0-20.7706909-16.9943848-37.7648926-37.7647705-37.7648926h450.5252686 c20.7706299,0,37.7648926-16.9942017,37.7648926-37.7649536v-0.000061 C1956.3061523,696.7625732,1939.3118896,679.7683716,1918.5412598,679.7683716z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159440824975474343260000006693283366215932326_",
    gradientUnits: "userSpaceOnUse",
    x1: 600.060791,
    y1: 339.8840942,
    x2: 1773.8323975,
    y2: 339.8840942
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3762B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F72A33"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159440824975474343260000006693283366215932326_)"
    },
    d: "M637.8256836,377.6489868H1736.067627 c20.7706299,0,37.7647705-16.9942017,37.7647705-37.764801v-0.0000916 c0-20.7706909-16.9941406-37.7648926-37.7647705-37.7648926H637.8256836 c-20.7706909,0-37.7648926,16.9942017-37.7648926,37.7648926v0.0000916 C600.060791,360.6547852,617.0549927,377.6489868,637.8256836,377.6489868z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124148130589297497920000011166919033063951493_",
    gradientUnits: "userSpaceOnUse",
    x1: 1126.9593506,
    y1: 264.354248,
    x2: 1620.8637695,
    y2: 264.354248
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3762B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F72A33"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124148130589297497920000011166919033063951493_)"
    },
    d: "M1164.7236328,264.354187 c0,20.7709961-16.9937744,37.7648926-37.7642822,37.7648926h456.1396484 c20.7703857,0,36.135498-16.9938965,36.135498-37.7648926h1.6292725c0-20.7706604-16.9943848-37.7647858-37.7647705-37.7647858 h-456.1396484C1147.7298584,226.5894012,1164.7236328,243.5835266,1164.7236328,264.354187z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112613137029553289450000017423511662328511147_",
    gradientUnits: "userSpaceOnUse",
    x1: 759.2288208,
    y1: 113.2946472,
    x2: 1550.6699219,
    y2: 113.2946472
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3762B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F72A33"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000112613137029553289450000017423511662328511147_)"
    },
    d: "M796.9937134,75.5298004h160.5927734 c20.7703857,0,37.7643433,16.9940948,37.7643433,37.7647934c0,20.7710037-16.9939575,37.7649002-37.7643433,37.7649002 h-61.4140015c-20.7706909,0-37.7648926,16.9942017-37.7648926,37.7648926v0.0001068 c0,20.7705994,16.9942017,37.764801,37.7648926,37.764801h616.7325439 c20.7706299,0,37.7648926-16.9942017,37.7648926-37.764801v-0.0001068 c0-20.7706909-16.9942627-37.7648926-37.7648926-37.7648926h-99.178833 c20.7703857,0,36.135376-16.9938965,36.135376-37.7649002h1.6293945c0-20.7706985-16.9943848-37.7647934-37.7647705-37.7647934 h-0.0001221c20.770752,0,37.7648926-16.9942017,37.7648926-37.7649002v-0.000103 C1451.4909668,16.9941998,1434.4968262,0,1413.7260742,0H796.9937134 c-20.7706909,0-37.7648926,16.9941998-37.7648926,37.7647972v0.000103 C759.2288208,58.5355988,776.2230225,75.5298004,796.9937134,75.5298004z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139978252464612015840000003666639196708379532_",
    gradientUnits: "userSpaceOnUse",
    x1: 778.5842896,
    y1: 415.414032,
    x2: 1533.0777588,
    y2: 415.414032
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3762B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F72A33"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000139978252464612015840000003666639196708379532_)"
    },
    d: "M1533.0777588,415.414093v-0.0000916 c0-20.7707214-16.9942627-37.7648926-37.7650146-37.7648926h-678.963562 c-20.770752,0-37.7648926,16.9941711-37.7648926,37.7648926v0.0000916 c0,20.7706909,16.9941406,37.7648926,37.7648926,37.7648926h678.963562 C1516.0834961,453.1789856,1533.0777588,436.1847839,1533.0777588,415.414093z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102544234949464482660000006754560844233095864_",
    gradientUnits: "userSpaceOnUse",
    x1: 893.678772,
    y1: 1170.7122803,
    x2: 1387.583252,
    y2: 1170.7122803
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3762B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F72A33"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000102544234949464482660000006754560844233095864_)"
    },
    d: "M893.678772,1208.4770508h456.1397095 c20.7703857,0,36.135498-16.9937744,36.135498-37.7646484h1.6292725c0-20.770752-16.9943848-37.7648926-37.7647705-37.7648926 H893.678772c20.7705078,0,37.7643433,16.9941406,37.7643433,37.7648926 C931.4431152,1191.4832764,914.4492798,1208.4770508,893.678772,1208.4770508z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016069892202018971260000016851758958919229335_",
    gradientUnits: "userSpaceOnUse",
    x1: 472.2358093,
    y1: 1019.6525269,
    x2: 1646.0074463,
    y2: 1019.6525269
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3762B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F72A33"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016069892202018971260000016851758958919229335_)"
    },
    d: "M1608.2425537,981.8876953 H510.0007019c-20.7706909,0-37.7648926,16.9940796-37.7648926,37.7647705v0.0001221 c0,20.7706299,16.9942017,37.7647705,37.7648926,37.7647705h1098.2418213 c20.770752,0,37.7648926-16.9941406,37.7648926-37.7647705v-0.0001221 C1646.0074463,998.8817749,1629.0133057,981.8876953,1608.2425537,981.8876953z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122703913360799018260000010559266254588512680_",
    gradientUnits: "userSpaceOnUse",
    x1: 712.9904785,
    y1: 1246.2420654,
    x2: 1405.2526855,
    y2: 1246.2420654
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3762B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F72A33"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122703913360799018260000010559266254588512680_)"
    },
    d: "M1367.487793,1208.4771729 H750.7553711c-20.7706909,0-37.7648926,16.9942627-37.7648926,37.7648926 c0,20.770874,16.9942017,37.7648926,37.7648926,37.7648926h616.7324219 c20.770752,0,37.7648926-16.9940186,37.7648926-37.7648926 C1405.2526855,1225.4714355,1388.2585449,1208.4771729,1367.487793,1208.4771729z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000076573310870128878360000005307745446582564540_",
    gradientUnits: "userSpaceOnUse",
    x1: 624.6550903,
    y1: 1095.1824951,
    x2: 1379.1484375,
    y2: 1095.1824951
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3762B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F72A33"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000076573310870128878360000005307745446582564540_)"
    },
    d: "M1379.1484375,1095.1824951 v-0.0001221c0-20.7706299-16.9942627-37.7648926-37.7648926-37.7648926H662.4197998 c-20.7706299,0-37.7647095,16.9942627-37.7647095,37.7648926v0.0001221 c0,20.770752,16.9940796,37.7648926,37.7647095,37.7648926h678.9637451 C1362.1541748,1132.9473877,1379.1484375,1115.9532471,1379.1484375,1095.1824951z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.6d32465c39ef9bdb1fe6145301f62073.svg";
export { ForwardRef as ReactComponent };